<wbo-edit-page #editPage [title]="model.data.name">
    <fui-rows [formGroup]="editPage.formGroup">
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <fui-append-field>
                        <wbo-text-edit-control formControlName="name"
                                               [(ngModel)]="model.data.name"></wbo-text-edit-control>
                        <wbo-text-edit-control formControlName="symbol"
                                               [(ngModel)]="model.data.symbol"></wbo-text-edit-control>
                    </fui-append-field>
                </fui-column>

                <fui-column>
                    <wbo-checkbox-edit-control formControlName="base"
                                               [(ngModel)]="model.data.base"
                                               [readonly]="restrictedBaseMeasureId"
                                               (valueChange)="baseChanged()"
                                               [readonlyOnEdit]="true"></wbo-checkbox-edit-control>
                </fui-column>

            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns formGroupName="baseConversion">
                <fui-column formGroupName="convertTo">
                    <wbo-measure-single-select-edit-control formControlName="measureId" [readonlyOnEdit]="true"
                                                            [(ngModel)]="model.data.baseConversion.convertTo.measureId"
                                                            [base]="true"
                                                            [readonly]="this.model.data.base || restrictedBaseMeasureId"
                                                            [overrideRequired]="!this.model.data.base"></wbo-measure-single-select-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-numeric-edit-control formControlName="factor" [(ngModel)]="model.data.baseConversion.factor"
                                              [readonly]="this.model.data.base"
                                              [overrideRequired]="!this.model.data.base"></wbo-numeric-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <fui-tandem-field>
                        <wbo-checkbox-edit-control
                            [(ngModel)]="hasCntQty" (valueChange)="disableCntQtyOnChange()"
                            [ngModelOptions]="{standalone: true}"
                            [label]="'wbo.measure.edit.field.hasCntQty.label'"></wbo-checkbox-edit-control>
                        <wbo-numeric-edit-control formControlName="ctnQty" [(ngModel)]="model.data.ctnQty"
                                                  [readonly]="!hasCntQty"
                                                  [overrideRequired]="hasCntQty"></wbo-numeric-edit-control>
                    </fui-tandem-field>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-rows>
</wbo-edit-page>
